export type TUnknownRecord = Record<string, unknown>

export const isRecord = (value: unknown): value is TUnknownRecord =>
    Boolean(value) && typeof value === 'object' && !Array.isArray(value)

export const asString = (value: unknown): string => {
    if (value === null || value === undefined) {
        return ''
    }

    return String(value)
}

export const firstNonEmpty = (...values: unknown[]): string => {
    for (const value of values) {
        const stringValue = asString(value).trim()
        if (stringValue) {
            return stringValue
        }
    }

    return ''
}
